import angular from 'angular';
import ConfigService from './config.service';
import ConstantsService from './constants.service';

export default angular.module('autoboard.config', [ConfigService, ConstantsService])
  .name;